export const Environment = {
  BASE_API: process.env.REACT_APP_BASE_API,
  SOCKET_URL: process.env.REACT_APP_SOCKET_URL,
};
